import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDropdown && _ctx.showDropdown(...args))),
          id: "dropBtn",
          class: "dropbtn"
        }, _toDisplayString(_ctx.btn_title ? _ctx.btn_title : "Please Select"), 1),
        _createElementVNode("div", {
          id: "myDropdown",
          class: "dropdown-content",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectItem && _ctx.selectItem(...args)))
        }),
        (_ctx.error !== undefined)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}